import { createValidator } from '@seek/validators-js';
import translations from '../.vocab';

// this matches the current adCentre backend regex being used
const containsPhoneRegex = /(.*[a-zA-Z0-9]){6}/;

export const { isPhone } = createValidator({
  test: ({ value }: { value: string }) => containsPhoneRegex.test(value),
  formatErrorMessages: (messages) => () =>
    messages['Invalid phone number'].format(),
  translations,
  validatorName: 'isPhone',
});

export default isPhone;
